<template>
  <LineChartGenerator
    :options="options"
    :data="chartData"
    :width="400"
    :height="220"
  />
</template>

<script>
// Ref: https://www.chartjs.org/docs/4.4.1/charts/line.html
import { Line as LineChartGenerator } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
);

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator,
  },
  props: {
    yearsData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      thisYear: new Date().getFullYear(),
      chartData: {
        labels: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        datasets: [],
      },
      options: {
        plugins: {
          legend: {
            reverse: true,
            position: 'bottom',
            align: 'start',
            labels: {
              boxHeight: 0,
            },
          },
          decimation: {
            enabled: false,
          },
        },
        responsive: true,
        scales: {
          // eslint-disable-next-line id-length
          x: {
            ticks: {
              padding: 16,
            },
            border: {
              display: false,
            },
            grid: {
              drawTicks: false,
              drawOnChartArea: false,
            },
          },
          // eslint-disable-next-line id-length
          y: {
            ticks: {
              precision: 0,
              padding: 8,
            },
            border: {
              display: false,
            },
          },
        },
      },
    };
  },
  created() {
    this.chartData.datasets = this.mapDatasets(this.yearsData);
  },
  methods: {
    mapDatasets(datasets) {
      const template = {
        label: '',
        data: [],
        backgroundColor: '',
        borderColor: '',
        pointBackgroundColor: 'rgb(255, 255, 255)',
        pointBorderColor: 'rgba(193, 199, 205, 1)',
        borderWidth: 3,
        pointRadius: 3,
        pointBorderWidth: 3,
      };

      return Object.entries(datasets).map(([year, statistics]) => ({
        ...template,
        label: year,
        data: statistics,
        backgroundColor:
          Number(year) === this.thisYear
            ? 'rgba(49, 123, 133, 1)'
            : 'rgba(193, 199, 205, 1)',
        borderColor:
          Number(year) === this.thisYear
            ? 'rgba(49, 123, 133, 1)'
            : 'rgba(193, 199, 205, 1)',
        order: this.thisYear - Number(year),
      }));
    },
  },
};
</script>
